const EMBED_PARAM = 'embed';
const EMBED_VALUE = '1';
let embedLocationWatcherReady = false;
let lastEmbedHref = '';

const getSearchParams = (search) => {
  if (search !== undefined) {
    return new URLSearchParams(search || '');
  }

  if (typeof window === 'undefined') {
    return new URLSearchParams('');
  }

  return new URLSearchParams(window.location.search || '');
};

const isEmbedMode = (search) => {
  const value = getSearchParams(search).get(EMBED_PARAM);
  const embedded = value === EMBED_VALUE || value === 'true';

  if (embedded && typeof window !== 'undefined') {
    watchEmbedLocation();
  }

  return embedded;
};

const withEmbedParam = (to, search) => {
  if (!isEmbedMode(search) || !to || /^https?:\/\//i.test(to)) {
    return to;
  }

  const [path, query = ''] = to.split('?');
  const params = getSearchParams(search);
  new URLSearchParams(query).forEach((value, key) => {
    params.set(key, value);
  });
  params.set(EMBED_PARAM, EMBED_VALUE);

  return `${path}?${params.toString()}`;
};

const contentBottom = () => {
  const elements = document.body?.getElementsByTagName('*') || [];
  let bottom = 0;

  for (let index = 0; index < elements.length; index += 1) {
    bottom = Math.max(
      bottom,
      elements[index].getBoundingClientRect().bottom + window.scrollY
    );
  }

  return bottom;
};

const postEmbedReset = () => {
  const message = { type: 'pintuna:embed:reset' };
  window.parent?.postMessage(message, '*');
};

function scheduleEmbedHeight() {
  window.requestAnimationFrame(postEmbedHeight);
  window.setTimeout(postEmbedHeight, 100);
  window.setTimeout(postEmbedHeight, 300);
}

const onEmbedLocationChange = () => {
  if (lastEmbedHref === window.location.href) {
    return;
  }

  lastEmbedHref = window.location.href;
  postEmbedReset();
  scheduleEmbedHeight();
};

const watchEmbedLocation = () => {
  if (embedLocationWatcherReady) {
    return;
  }

  embedLocationWatcherReady = true;
  lastEmbedHref = window.location.href;

  ['pushState', 'replaceState'].forEach((name) => {
    const original = window.history[name];
    window.history[name] = function historyStateChange() {
      const result = original.apply(this, arguments);
      window.setTimeout(onEmbedLocationChange, 0);
      return result;
    };
  });

  window.addEventListener('popstate', onEmbedLocationChange);
};

const postEmbedHeight = () => {
  if (typeof window === 'undefined' || !isEmbedMode()) {
    return;
  }

  watchEmbedLocation();

  const body = document.body;
  const html = document.documentElement;
  const app = document.getElementById('___gatsby');
  const fallbackHeight = Math.max(
    body?.scrollHeight || 0,
    body?.offsetHeight || 0,
    html?.scrollHeight || 0,
    html?.offsetHeight || 0,
    app?.scrollHeight || 0,
    app?.offsetHeight || 0
  );
  const height = Math.ceil(contentBottom() || fallbackHeight);

  const message = {
    type: 'pintuna:embed:resize',
    height,
  };

  window.parent?.postMessage(message, '*');
  window.parent?.postMessage({ ...message, type: 'pintuna-resize' }, '*');
};

export { isEmbedMode, withEmbedParam, postEmbedHeight };
